import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { SmoothScrollProvider, useSmoothScroll } from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CallButton from "@/components/CallButton";
import RouteSeo from "@/components/RouteSeo";
import StaticPageHandler, { isStaticSeoPath } from "@/components/StaticPageHandler";
import Home from "@/pages/Home";
import About from "@/pages/About";
import GlobalPresence from "@/pages/GlobalPresence";
import Portfolio from "@/pages/Portfolio";
import BecomeCustomer from "@/pages/BecomeCustomer";
import BecomeSupplier from "@/pages/BecomeSupplier";
import Contact from "@/pages/Contact";

// Film grain overlay component
function FilmGrain() {
  return <div className="grain-overlay" aria-hidden="true" />;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useSmoothScroll();
  
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, lenis]);
  
  return null;
}

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isStaticPage = isStaticSeoPath(location.pathname);
  
  // If this is a static SEO page path, don't render React content
  // Let StaticPageHandler redirect to the static HTML file
  if (isStaticPage) {
    return <StaticPageHandler />;
  }
  
  return (
    <div className="min-h-screen bg-bg text-ink">
      {!isHomePage && <FilmGrain />}
      <ScrollToTop />
      <RouteSeo />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/global-presence" element={<GlobalPresence />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/become-customer" element={<BecomeCustomer />} />
        <Route path="/become-supplier" element={<BecomeSupplier />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      {!isHomePage && <Footer />}
      {!isHomePage && <WhatsAppButton />}
      {!isHomePage && <CallButton />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SmoothScrollProvider>
        <AppContent />
      </SmoothScrollProvider>
    </BrowserRouter>
  );
}

export default App;
